export default __webpack_public_path__ + "/dist/images/company-active.b98a5ee6bb54d4252d148f86918e8964.svg";